
//const videourl = "http://api.evolve.de/vgh/api/public/videos";
const videourl = "https://api.evolvejobs.de/vgh/api/public/videos";
export default videourl;